module.exports = __webpack_public_path__ + "img/GAME_HORSE2.0714ba78.jpg";